<template>
<v-dialog v-model="show" :max-width="dialogWidth" scrollable persistent>
    <v-card elevation="5" class="rounded-lg">
        <v-card-title class="text-h5 lighten-2">Actualizar stock (dosis)&nbsp;<span v-if="loteSelected">- lote {{ loteSelected.loteId }}</span>
        </v-card-title>
        <v-card-text>
            <v-form lazy-validation ref="form">
                <v-container>
                    <v-row>
                        <v-col>
                            <v-text-field v-model="quantity" label="Ingresa cantidad de dosis" hide-no-data outlined dense clearable type="number" :rules="validation()"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-container fluid>
                <v-row>
                    <v-col cols="">
                        <v-btn color="red" block @click="closeModal" dark>Cancelar</v-btn>
                    </v-col>
                    <v-col>
                        <v-btn color="primary" block @click="confirmation">Guardar</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
//vuex
import {
    mapActions,
    mapMutations,
    mapState
} from "vuex";
//validations
import {
    requiredValidation
} from "@/helpers/validations.js";
export default {
    data: () => ({
        quantity: null,
    }),
    props: {
        value: Boolean,
    },
    computed: {
        ...mapState("lotes", ["loteSelected"]),
        dialogWidth() {
            if (this.$vuetify.breakpoint.xs) return "90vw"; // Extra pequeño
            if (this.$vuetify.breakpoint.sm) return "70vw"; // Pequeño
            if (this.$vuetify.breakpoint.md) return "60vw"; // Mediano
            return "50vw"; // Grande en adelante
        },
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    methods: {
        ...mapActions("lotes", ["updateStock"]),
        closeModal() {
            this.show = false;
        },
        validation(name) {
            return requiredValidation(name);
        },
        async confirmation() {
            if (this.$refs.form.validate()) {
                try {
                    let payload = {
                        newStock: this.quantity
                    }
                    let params = {
                        loteId: this.loteSelected._id
                    }
                    await this.updateStock({
                        params: params,
                        body: payload
                    })
                    this.$swal({
                        icon: "success",
                        title: `Lote actualizado`,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    this.loteSelected.manualStock = this.quantity
                    this.quantity = null
                    this.show = false
                } catch (error) {
                    console.log(error);
                    this.$swal({
                        icon: "error",
                        title: `Algo salió mal. Error: ${error.message}`,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                }
                // this.$emit("addQuantity", this.replicatesQuantity);
                // this.replicatesQuantity = null
                // this.$refs.form.reset()
            }
        },
    },
    watch: {
        show(value) {
            if (value) {
                this.quantity = this.loteSelected.manualStock || 0
            }
        }
    },
};
</script>
